type Title = {
  title: string;
};
type Label = {
  label: string;
};

const itemIsTitle = (item: unknown): item is Title => {
  if (item && typeof item === 'object' && 'title' in item) {
    return typeof item.title === 'string';
  }

  return false;
};
const itemIsLabel = (item: unknown): item is Label => {
  if (item && typeof item === 'object' && 'label' in item) {
    return typeof item.label === 'string';
  }

  return false;
};
const itemToStringDefault = <T>(item: T | null) => {
  if (typeof item === 'string' || typeof item === 'number') {
    return item.toString();
  }

  if (itemIsTitle(item)) {
    return item.title;
  }

  if (itemIsLabel(item)) {
    return item.label;
  }

  return '';
};

const appendUniqueByString = <T>(
  prevItems: T[],
  nextItems: T[],
  itemToString: (item: T | null) => string
): {items: T[]; appendedCount: number} => {
  const seen = new Set(prevItems.map(item => itemToString(item)));
  const unique = nextItems.filter(item => !seen.has(itemToString(item)));

  return {
    items: unique.length > 0 ? [...prevItems, ...unique] : prevItems,
    appendedCount: unique.length,
  };
};

export {appendUniqueByString, itemToStringDefault};
